import "./filter.scss";
import { useState, useEffect, useContext } from "react";
import { addDays } from "date-fns";
import {factoryStartTime, factoryEndTime, Epoch, factoryStartEndTime} from '../../Hooks/Common'
import { useTranslation } from "react-i18next";
import enUS from "rsuite/locales/en_US";
import zhLocale from "rsuite/locales/zh_CN";

import Dropdown from "../dropdown";
import FilterContext from "../../Hooks/Context";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDateTimePicker from "@mui/lab/MobileDateTimePicker";
import DesktopDateTimePicker from "@mui/lab/DesktopDateTimePicker";
import DatePicker from "@mui/lab/DatePicker";
import {CONSTANTS} from '../../Api/Constants'
import moment from "moment";

const Filter = ({
  isPickerEnable,
  GenerateFilters,
  showDatePicker,
  currentLanguage,
  startDate,
  endDate,
}) => {
  const [language, SetLanguage] = useState(currentLanguage);
  const [factoryFilterData, SetFactoryFilterData] = useState();
  const [lineFilterData, SetineFilterData] = useState();
  const [shiftFilterData, SetShiftFilterData] = useState();
  const { t } = useTranslation();
  const [startValue, setStartValue] = useState(startDate);
  const [endValue, setEndValue] = useState(endDate);
  const [currentDayValue, setCurrentDayValue] = useState(new Date());
  const [updateDatepicker, SetUpdateDatepicker] = useState(null);
  const [betweenLive, setBetweenLive] = useState(false);
  const [shiftData, SetShiftData] = useState([
    { id: "1", label: "All Shift" },
    { id: "2", label: "Shift A" },
    { id: "3", label: "Shift B" }
  ]);

  const filterQueries = useContext(FilterContext);

  /* Mock data for dropdown */
  const factoryData = [
    { id: "1", label: "All Factories" },
    { id: "2", label: "Flexunion" },
  ];

  const lineDropdownData = [
    { id: "1", label: "All Lines" },
    { id: "2", label: "Line 2" }
  ];

  useEffect(() => {
    SetUpdateDatepicker(true);
  }, []);

  useEffect(() => {
    if (!showDatePicker) {
      //setStartValue(factoryStartTime());
      //setEndValue(factoryEndTime());
    }
  }, []);

  const UpdateFilterValues = (updatedValue) => {
    let startOfDay = moment(updatedValue).hours(CONSTANTS.SHIFT.STARTHOUR).minutes(CONSTANTS.SHIFT.STARTMIN).seconds(CONSTANTS.SHIFT.STARTSEC).unix();
    let endOfDay = moment(updatedValue).hours(CONSTANTS.SHIFT.ENDHOUR).minutes(CONSTANTS.SHIFT.ENDMIN).seconds(CONSTANTS.SHIFT.ENDSEC).unix();
    let filterRequestQuery = {
      factory: "",
      lines: "",
      shift: "",
      startTs: startOfDay,
      endTs: endOfDay,
      isLive: false
    };
    filterQueries.GenerateFilters(filterRequestQuery);
  };

  const SetStartValueToQuery = (newValue, timeStamp) => {
    let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
    let startDate =  (timeStamp === 'startTs') ? moment(newValue).unix() : 
      filterRequestQuery['startTs'];
      
    let endDateValue = addDays(newValue, 1);
    endDateValue = moment(endDateValue).hours(CONSTANTS.SHIFT.ENDHOUR).minutes(CONSTANTS.SHIFT.ENDMIN).seconds(CONSTANTS.SHIFT.ENDSEC);
    let endDate = (timeStamp === 'endTs') ? moment(newValue).unix() : endDateValue.unix();
    
    if (timeStamp === 'startTs') {
      let eDate = addDays(newValue, 1);
      eDate.setHours(CONSTANTS.SHIFT.ENDHOUR)
      eDate.setMinutes(CONSTANTS.SHIFT.ENDMIN)
      eDate.setSeconds(CONSTANTS.SHIFT.ENDSEC)
      setEndValue(eDate)
    }
    
    let fset = factoryStartEndTime();
    let liveStart = fset.startTs;
    let liveEnd = fset.endTs;

    if ( liveStart <= startDate && startDate <= liveEnd && endDate <= liveEnd && endDate >= startDate){
      filterRequestQuery.isLive = true;
      setBetweenLive(true);
    } else {
      setBetweenLive(false);
      filterRequestQuery.isLive = false;
    }
    
    filterRequestQuery['startTs'] = startDate;
    filterRequestQuery['endTs'] = endDate;
    filterQueries.GenerateFilters(filterRequestQuery);
  };

  const localeMap = {
    en: enUS,
    zh: zhLocale,
  };

  useEffect(() => {
    if(filterQueries.filterRequestQuery.isLive && !betweenLive) {
      setStartValue(factoryStartTime());
      setEndValue(factoryEndTime());
      setCurrentDayValue(new Date());
    }

  }, [filterQueries.filterRequestQuery]);

  return (
    <div className="filter-container">
      {factoryData && (
        <Dropdown
          selectedLanguage={language}
          data={factoryData}
          placeholder={t("LT_select_factory")}
          selectedItem={factoryData[0]}
          name="factory"
          GenerateFilters={GenerateFilters}
        />
      )}
      {lineDropdownData && (
        <Dropdown
          data={lineDropdownData}
          placeholder={t("LT_select_line")}
          selectedItem={lineDropdownData[0]}
          name="lines"
          GenerateFilters={GenerateFilters}
        />
      )}
      {!showDatePicker && !isPickerEnable && (
        <LocalizationProvider
          key={language}
          dateAdapter={AdapterDateFns}
          locale={localeMap[currentLanguage]}
        >
          <div className="mobile-only">
            <MobileDateTimePicker
              value={startValue}
              maxDate={new Date()}
              onChange={(newValue) => {
                setStartValue(newValue);
                SetStartValueToQuery(newValue, "startTs");
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
          <div className="desktop-only">
            <DesktopDateTimePicker
              value={startValue}
              maxDate={new Date()}
              onChange={(newValue) => {
                setStartValue(newValue);
                SetStartValueToQuery(newValue, "startTs");
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
          <div className="mobile-only">
            <MobileDateTimePicker
              minDate={startValue}
              // minTime={addMinutes(startValue, 1)}
              maxDate={addDays(startValue,1) }
              value={endValue}
              onChange={(newValue) => {
                setEndValue(newValue);
                SetStartValueToQuery(newValue, "endTs");
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
          <div className="desktop-only">
            <DesktopDateTimePicker
              minDate={startValue}
              // minTime={addMinutes(startValue, 1)}
              maxDate={addDays(startValue,1) }
              value={endValue}
              onChange={(newValue) => {
                setEndValue(newValue);
                SetStartValueToQuery(newValue, "endTs");
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
        </LocalizationProvider>
      )}

      {showDatePicker && !isPickerEnable && (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <div className="mobile-datepicker-only">
            <DatePicker
              maxDate={new Date()}
              value={currentDayValue}
              onChange={(newValue) => {
                setCurrentDayValue(newValue);
                UpdateFilterValues(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
        </LocalizationProvider>
      )}
      {shiftData && (
        <Dropdown
          data={shiftData}
          key={updateDatepicker}
          placeholder={t("LT_select_shift")}
          selectedItem={shiftData[0]}
          name="shift"
        />
      )}
    </div>
  );
};

export default Filter;
